/**
 * Component: basicDetailsReducer.js
 * Description: This reducer manages the state related to basic details of the asset.
 */

const initialState = {   
    "fromDate": "",      
    "toDate": "",        
    "hospitalId": "",   
    "groupById": "",                              
    "assetStatusId": "",
    "authorized": true,
    "assetTypecodeid": "",                       
    "locationid": ""   
    };
  
  const assetAnalysisReportFilter = (state = initialState, action) => {
    switch (action.type) {
      case 'UPDATE_ASSET_REPORTS_DETAILS':
        return {
          ...state,
          ...action.payload,
        };
      case 'CLEAR_ASSET_REPORTS_DETAILS':
        return initialState; // Reset to initial state
      default:
        return state;
    }
    
  };
  
  export default assetAnalysisReportFilter;
  